import { MULTIPLE_USER_POWER_AGREEMENT } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsSystemPowerSingleOrMultipleUsersEqualTo,
  IsSystemPowerCommunityOrPPALeaseEqualTo,
  IsApplicationSolar,
} from '../rules';

class OfftakerPPAorLeaseAgreementRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (!IsApplicationSolar.evaluate(data)) return RulesetResult.HIDDEN;
    const isSingleUser =
      IsSystemPowerSingleOrMultipleUsersEqualTo.setValue(
        'Single User'
      ).evaluate(data);
    const isMultipleUsers =
      IsSystemPowerSingleOrMultipleUsersEqualTo.setValue(
        'Multiple Users'
      ).evaluate(data);
    const isPPALease = IsSystemPowerCommunityOrPPALeaseEqualTo.setValue(
      MULTIPLE_USER_POWER_AGREEMENT.PPA_LEASE
    ).evaluate(data);

    if (isSingleUser || (isMultipleUsers && isPPALease))
      return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}
export default new OfftakerPPAorLeaseAgreementRuleset();
